import React from 'react';
import {
    Typography,
    Divider,
    Button,
    Card,
} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import ShareIcon from '@mui/icons-material/Share';
import CardMedia from '@mui/material/CardMedia';
import A8Agoda from '../../components/A8/A8Agoda';
import CATEGORY_IMAGE from '../../../static/biz-professional/teapot-6123749_1280.jpeg';
import { useNavigate } from 'react-router-dom';

interface ArticlePageProps {
    path: string;
}


const Article: React.FC<ArticlePageProps> = ({ path }) => {
    const handleCopyClick = () => {
        navigator.clipboard.writeText(path)
            .then(() => {
                console.log('Link copied to clipboard!');
            })
            .catch((err) => {
                console.error('Unable to copy link to clipboard', err);
            });
    };

    const navigate = useNavigate()
    const handleImageClick = (path: string) => {
        navigate(path);
        window.scrollTo(0, 0);
    };
    return (
        <div>
            <Box sx={{ mt: 7, mb: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <Card elevation={0} sx={{ maxWidth: 1000 }} style={{ margin: '0px', padding: '5px' }}>
                    <CardContent>
                        <Typography variant="h1" id="introduction" style={{ fontSize: '30px' }}>
                            第7回: 実例から学ぼう。トップティア戦コンの実際のプレゼン資料
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="body2" color="text.primary">
                            Published on 2024 Jan 17th <br />
                            10 min read  <br />
                            by Michelle
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            これまで6回に渡り、プレゼンテーションの初級から中級までのスキルを学んできました。各回ではセオリーとしての考え方を説明するとともに、
                            戦略コンサルティングファームの実際の資料を実践例として紹介することで、理論と実践の双方の面からプレゼンテーションの各種技法を理解できたものと思います。<br /><br />

                            6回までの手法をすべて丁寧に実践すれば、プレゼンテーションという文脈においては、大手企業におけるセクションマネージャ（部下50人程度の管理職）程度は務まるでしょう。<br /><br />

                            第7回ではプレゼンテーションのスキルを説明してきた今までとは異なり、単に戦略コンサルティングファームの資料を掲載したいと思います。既に第6回までに紹介した資料もありますが、
                            みなさんには改めて実践例としてこれらをみて頂くことで、プロフェッショナルに求められるプレゼンテーションを体感していただき、日々の業務の参考にしていただければと思います。<br /><br />

                            戦略コンサルティングファームの資料が公開されることは極めて少ないので、それらは貴重な参考資料となるでしょう。<br /><br />
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Button variant="text" size="small" endIcon={<ShareIcon />} style={{ color: 'black' }} onClick={handleCopyClick}>
                            Copy URL of this ariticle
                        </Button>
                    </CardContent>
                    <CardMedia
                        component="img"
                        height="500"
                        sx={{

                            objectFit: 'cover',
                            filter: 'grayscale(90%)',
                        }}
                        image={CATEGORY_IMAGE}
                        alt="image of the category"
                    />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                            第7回: 実例から学ぼう。トップティア戦コンの実際のプレゼン資料
                        </Typography>
                    </CardContent>
                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px', fontWeight: 'lighter' }}>Table of Contents</Typography>
                    </CardContent>
                    <ol>
                        <li><a href="#1">トップティア戦略コンサルファームの実際のプレゼン資料集。</a></li>
                        <li><a href="#2">最後に一言。</a></li>
                    </ol>
                    <Divider id="1" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>トップティア戦略コンサルファームの実際のプレゼン資料集。</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            第1回から第6回までに学んだプレゼンテーションの各スキルを意識しながら各資料を見ると、今までとは異なる視点での学びが数多くあるでしょう。
                            <br />
                            <br />
                            {/*  */}
                            <Divider id="2" style={{ margin: '40px 0' }} />
                            <Typography variant="h3" color="text.secondary" style={{ fontSize: '25px' }}>
                                McKinsey & Company, Inc.
                            </Typography>
                            <CardContent>
                                <Typography variant="body2" color="text.primary">
                                    Founded in 1926 at USA  <br />
                                    by James O. McKinsey - a professor at the University of Chicago
                                </Typography>
                            </CardContent>
                            <CardContent>
                                <Typography paragraph style={{ fontSize: '22px' }}>
                                    <a href="https://www.meti.go.jp/meti_lib/report/2020FY/000245.pdf" target="_blank" rel="noopener noreferrer">
                                        令和2年度戦略的基盤技術<br />
                                        高度化・連携支援事業
                                        (中小企業のAI活用促進に関する調査事業)
                                    </a>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    出典: METI - www.meti.go.jp
                                </Typography>
                            </CardContent>
                            <CardContent>
                                <Typography paragraph style={{ fontSize: '22px' }}>
                                    <a href="https://www.meti.go.jp/shingikai/enecho/shigen_nenryo/sekiyu_gas/pdf/001_04_00.pdf" target="_blank" rel="noopener noreferrer">
                                        我が国製油所の国際競争力
                                    </a>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    出典: METI - www.meti.go.jp
                                </Typography>
                            </CardContent>
                            {/*  */}

                            {/*  */}
                            <Divider id="3" style={{ margin: '40px 0' }} />
                            <Typography variant="h3" color="text.secondary" style={{ fontSize: '25px' }}>
                                Boston Consulting Group
                            </Typography>
                            <CardContent>
                                <Typography variant="body2" color="text.primary">
                                    Founded in 1963 at Boston, USA  <br />
                                    by Bruce Henderson (from Arthur D. Little)
                                </Typography>
                            </CardContent>
                            <CardContent>
                                <Typography paragraph style={{ fontSize: '22px' }}>
                                    <a href="https://www.meti.go.jp/meti_lib/report/2020FY/000410.pdf" target="_blank" rel="noopener noreferrer">
                                        令和2年度エネルギー需給構造<br />
                                        高度化対策に関する調査事業
                                        (洋上風力に係る官民連携の在り方の検討(サプライ
                                        チェーン形成に向けた仕組みの検討等)のための調査)
                                    </a>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    出典: METI - www.meti.go.jp
                                </Typography>
                            </CardContent>
                            <CardContent>
                                <Typography paragraph style={{ fontSize: '22px' }}>
                                    <a href="https://www.meti.go.jp/meti_lib/report/H30FY/000141.pdf" target="_blank" rel="noopener noreferrer">
                                        平成30年度商取引・サービス環境の適性化に係る事業
                                    </a>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    出典: METI - www.meti.go.jp
                                </Typography>
                            </CardContent>
                            {/*  */}

                            {/*  */}
                            <Divider id="4" style={{ margin: '40px 0' }} />
                            <Typography variant="h3" color="text.secondary" style={{ fontSize: '25px' }}>
                                Arthur D. Little
                            </Typography>
                            <CardContent>
                                <Typography variant="body2" color="text.primary">
                                    Founded in 1886 at Boston, USA  <br />
                                    by Arthur Dehon Little (from MIT)
                                </Typography>
                            </CardContent>
                            <CardContent>
                                <Typography paragraph style={{ fontSize: '22px' }}>
                                    <a href="https://www.meti.go.jp/meti_lib/report/2020FY/000368.pdf" target="_blank" rel="noopener noreferrer">
                                        バイオベンチャーの特性を踏まえた、
                                        非財務情報に基づく企業価値評価と
                                        上場制度の設計のあり方に関する調査
                                    </a>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    出典: METI - www.meti.go.jp
                                </Typography>
                            </CardContent>
                            {/*  */}

                            {/*  */}
                            <Divider id="5" style={{ margin: '40px 0' }} />
                            <Typography variant="h3" color="text.secondary" style={{ fontSize: '25px' }}>
                                A.T.Kearney
                            </Typography>
                            <CardContent>
                                <Typography variant="body2" color="text.primary">
                                    Founded in 1926 at Chicago, USA  <br />
                                    by Andrew Thomas Kearney
                                </Typography>
                            </CardContent>
                            <CardContent>
                                <Typography paragraph style={{ fontSize: '22px' }}>
                                    <a href="https://www.env.go.jp/press/y0618-16/mat02r.pdf" target="_blank" rel="noopener noreferrer">
                                        電力自由化の進展と電源ミックス及びCO2排出量への影響
                                    </a>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    出典: 環境省 - www.env.go.jp
                                </Typography>
                            </CardContent>
                            {/*  */}

                            {/*  */}
                            <Divider id="5" style={{ margin: '40px 0' }} />
                            <Typography variant="h3" color="text.secondary" style={{ fontSize: '25px' }}>
                                Roland Berger
                            </Typography>
                            <CardContent>
                                <Typography variant="body2" color="text.primary">
                                    Founded in 1967 at Munich, Germany <br />
                                    by Roland Berger
                                </Typography>
                            </CardContent>
                            <CardContent>
                                <Typography paragraph style={{ fontSize: '22px' }}>
                                    <a href="https://dl.ndl.go.jp/view/download/digidepo_11280274_po_000578.pdf?contentNo=1" target="_blank" rel="noopener noreferrer">
                                        平成26年度我が国経済社会の情報化・サービス化に係る基盤整備
                                    </a>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    出典: 国立国会図書館デジタルコレクション - https://dl.ndl.go.jp/
                                </Typography>
                            </CardContent>
                            {/*  */}

                            {/*  */}
                            <Divider id="5" style={{ margin: '40px 0' }} />
                            <Typography variant="h3" color="text.secondary" style={{ fontSize: '25px' }}>
                                Bain & Company
                            </Typography>
                            <CardContent>
                                <Typography variant="body2" color="text.primary">
                                    Founded in 1973 at Boston, USA  <br />
                                    by Bill Bain (Boston Consulting Group)
                                </Typography>
                            </CardContent>
                            <CardContent>
                                <Typography paragraph style={{ fontSize: '22px' }}>
                                    <a href="https://media.bain.com/Images/2011%20Bain%20China%20Luxury%20Market%20Study.pdf" target="_blank" rel="noopener noreferrer">
                                        2011 China Luxury Market Study
                                    </a>
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    出典: Bain & Company - https://bain.com
                                </Typography>
                            </CardContent>
                            {/*  */}
                        </Typography>
                    </CardContent>

                    <Divider id="4" style={{ margin: '40px 0' }} />
                    <CardContent>
                        <Typography variant="h4" style={{ fontSize: '30px' }}>最後に一言</Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="h5">
                            戦略コンサルティングファームの取り扱うプロジェクトは多岐に渡りますが、
                            社会的インパクトの大きいイシューに対して、重要な意思決定を支えるプレゼンテーション資料ばかりでしたね。<br /> <br />

                            理論を学んだあとに実例を見ると違った世界が見えたのではないでしょうか。
                            何事も理論の深掘りと実践の繰り返しが重要ですが、各ファームの資料を参考にするとともにそれを日々の業務に活かすことで、皆様のプレゼンテーションスキルがより向上することを願っています。
                        </Typography>
                    </CardContent>

                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <A8Agoda />
                    </CardContent>
                    <Button
                        variant="text"
                        size="small"
                        endIcon={<ShareIcon />}
                        style={{ color: 'black' }}
                        onClick={() => handleImageClick("/")}
                    >
                        他のプレゼンテーションスキルを学ぶ（記事一覧へ）
                    </Button>
                </Card>
            </Box>
        </div>
    );
};

export default Article;
